import styled, { css } from 'styled-components';
import { animated } from 'react-spring';

const toastTypeVariation = {
  info: css`
    //background-color: #ebf8ff !important;
    color: #3172b7 !important;
    border-left: 4px solid #3172b7 !important;
  `,
  success: css`
    //background-color: #e6fffa !important;
    color: #2e656a !important;
    border-left: 4px solid #2e656a !important;
  `,
  error: css`
    //background-color: #fed7d7 !important;
    color: #c53030 !important;
    border-left: 4px solid #c53030 !important;
  `,
  warning: css`
    //background-color: #feebc8 !important;
    color: #ff9000 !important;
    border-left: 4px solid #ff9000 !important;
  `,
};

export const Container = styled(animated.div).withConfig({
  shouldForwardProp: (prop) => prop !== 'type' && prop !== 'hasDescription',
})`
  border-radius: 10px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  padding: 16px 30px 16px 16px;
  position: relative;
  width: 360px;

  ${props => {
    const type = props.type || 'info';
    return toastTypeVariation[type] || toastTypeVariation.info;
  }}

  & + div {
    margin-top: 8px;
  }

  > svg {
    margin: 4px 12px 0 0;
    color: inherit;
    flex-shrink: 0;
  }

  div {
    flex: 1;

    p {
      font-size: 14px;
      line-height: 20px;
      margin-top: 4px;
      //opacity: 0.8;
    }
  }

  button {
    background: transparent;
    border: 0;
    color: inherit;
    //opacity: 0.6;
    position: absolute;
    right: 16px;
    top: 19px;
  }

  ${props =>
    !props.hasDescription &&
    css`
      align-items: center;

      svg {
        margin-top: 0;
      }
    `}
`;
